<template>
  <div class="admin-dashboard">
    <header-title title="Dashboard - Rankings"></header-title>
    <Loader :dialog-loader="loader" message="Cargando..."></Loader>
    <v-row justify="center">
      <v-col cols="12" lg="2" md="6" sm="6" xs="12">
        <v-select
          @change="onChangeDatePeriod"
          v-model="dateSelected"
          :items="dateDropdown"
          item-text="label"
          item-value="value"
          dense
          label="Selecciona un período"
          class="filters"
          outlined
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" lg="2" md="6" sm="6" xs="12">
        <v-menu
          v-model="menu2"
          class="pt-0"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Date range"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :first-day-of-week="1"
            v-model="dates"
            @change="onChangeDate"
            range
            locale="es"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" lg="2" md="6" sm="6" xs="12">
        <v-select
          @change="onChangeProductType"
          v-model="productTypeSelected"
          :items="typeDropdown"
          item-text="label"
          item-value="value"
          dense
          label="Tipo de producto"
          class="filters"
          outlined
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" lg="2" md="6" sm="6" xs="12">
        <v-btn dark @click="refreshData" class="filters">
          <v-icon dark> mdi-refresh </v-icon>
          &nbsp;Refrescar
        </v-btn>
      </v-col>
    </v-row>
    <v-container v-if="!loader" fluid class="dashboard-container">
      <h2 class="font-weight-bold">
        {{ dayFormat2(rangeOfDates.start) }} -
        {{ dayFormat2(rangeOfDates.end) }}
      </h2>
      <br />
      <v-row>
        <v-col lg="12" md="12" sm="12">
          <v-card class="mx-auto text-center" dark>
            <v-card-text class="font-weight-bold">
              Number of orders by email
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <EmailRankingChart :payments="payments"></EmailRankingChart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card class="mx-auto text-center" dark>
            <v-card-text class="font-weight-bold">
              TOP PRODUCTOS €
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <ProductPriceRankingChart
                  :orders="orders"
                  :productTypeSelected="productTypeSelected"
                ></ProductPriceRankingChart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card class="mx-auto text-center" dark>
            <v-card-text class="font-weight-bold">
              TOP PRODUCTOS UD.
            </v-card-text>
            <v-card-text>
              <v-sheet>
                <ProductSalesRankingChart
                  :orders="orders"
                  :productTypeSelected="productTypeSelected"
                ></ProductSalesRankingChart>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import { getDateFilter, getProductType } from "@/utils/constant";
import moment from "moment";
import dashboardMixin from "@/mixins/dashboard/dashboardMixin";
import EmailRankingChart from "@/components/admin/dashboard/EmailRankingChart";
import ProductSalesRankingChart from "@/components/admin/dashboard/ProductSalesRankingChart";
import ProductPriceRankingChart from "@/components/admin/dashboard/ProductPriceRankingChart";
import { getPaymentByRangeOfDates } from "@/collections/payments.js";
import { getZClousureByRangeOfDates } from "@/collections/zClousures.js";
import HeaderTitle from "@/components/admin/common/HeaderTitle";

const TODAY_VALUE = "today";
const LAST_MONTH_VALUE = "lastMonth";
const LAST_3MONTHS_VALUE = "last3Month";
const LAST_6MONTHS_VALUE = "last6Month";
const LAST_YEAR_VALUE = "lastYear";
const INITIAL_DATE_START = moment().startOf("day");
const INITIAL_DATE_END = moment().endOf("day");

export default {
  name: "Rankings",
  mixins: [dashboardMixin],
  components: {
    Loader,
    EmailRankingChart,
    ProductSalesRankingChart,
    ProductPriceRankingChart,
    HeaderTitle
  },
  data() {
    return {
      loader: false,
      menu2: false,
      dateSelected: "today",
      dateDropdown: [...getDateFilter],
      typeDropdown: [...getProductType],
      dates: [
        moment(INITIAL_DATE_START).format("YYYY-MM-DD"),
        moment(INITIAL_DATE_END).format("YYYY-MM-DD")
      ],
      productTypeSelected: "all",
      rangeOfDates: {},
      paymentHistory: [],
      orderHistory: []
    };
  },
  mounted() {
    this.dateSelected = "lastMonth";
    this.onChangeDatePeriod();
  },
  computed: {
    dateRangeText() {
      return this.dates?.join(" ~ ");
    },
    payments() {
      return this.paymentHistory;
    },
    orders() {
      return this.orderHistory;
    }
  },
  methods: {
    onChangeProductType(value) {
      this.productTypeSelected = value;
    },
    onChangeDatePeriod() {
      this.productTypeSelected = "all";

      const INITIAL_DATE_START = moment().startOf("day");
      const INITIAL_DATE_END = moment().endOf("day");

      if (this.dateSelected === TODAY_VALUE) {
        this.rangeOfDates = {
          start: INITIAL_DATE_START,
          end: INITIAL_DATE_END
        };
      }
      if (this.dateSelected === LAST_MONTH_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(1, "month");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }

      if (this.dateSelected === LAST_3MONTHS_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(3, "month");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }

      if (this.dateSelected === LAST_6MONTHS_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(6, "month");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }

      if (this.dateSelected === LAST_YEAR_VALUE) {
        let start = moment()
          .startOf("day")
          .subtract(1, "year");

        this.rangeOfDates = {
          start: start,
          end: INITIAL_DATE_END
        };
      }
      this.dates = [];
      this.dates[0] = moment(this.rangeOfDates.start).format("YYYY-MM-DD");
      this.dates[1] = moment(this.rangeOfDates.end).format("YYYY-MM-DD");
      this.onChangeDate(this.dates);
    },
    onChangeDate(_date) {
      this.menu2 = false;
      this.loader = true;
      this.rangeOfDates = {};
      this.rangeOfDates = {
        start: moment(_date[0]).toDate(),
        end: moment(_date[1]).toDate()
      };
      // Range selected
      this.rangeOfDates = this.buildRangeOfDates(this.rangeOfDates);
      this.paymentsByRangeOfDate(this.rangeOfDates);
      this.zClousureByRangeOfDate(this.rangeOfDates);
      this.loader = false;
    },
    refreshData() {
      let _date = [];
      _date[0] = this.rangeOfDates.start;
      _date[1] = this.rangeOfDates.end;
      this.onChangeDate(_date);
    },
    async paymentsByRangeOfDate(rangeOfDates) {
      try {
        this.paymentHistory = await getPaymentByRangeOfDates(
          rangeOfDates.start,
          rangeOfDates.end
        );
      } catch (error) {
        this.setlogError(
          "get_payment_date_range",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async zClousureByRangeOfDate(rangeOfDates) {
      try {
        this.orderHistory = await getZClousureByRangeOfDates(
          rangeOfDates.start,
          rangeOfDates.end
        );
      } catch (error) {
        this.setlogError(
          "get_zclousure_date_range",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style></style>
